import { useRef, useMemo, useCallback, useEffect } from 'react';

/**
 * A refactor of navigation.js.coffee from CoffeeScript to a React hook.
 */
function useAskTheExpertPosition() {
  const elementRef = useRef();

  const lessonViewer = useMemo(
    () => document.querySelector('.lesson_viewer'),
    [],
  );

  const setPosition = useCallback(() => {
    const lessonViewerRect = lessonViewer.getBoundingClientRect();
    const elementRect = elementRef.current.getBoundingClientRect();
    if (elementRect.top < lessonViewerRect.top) {
      elementRef.current.style.paddingTop = `${
        lessonViewerRect.top - elementRect.top
      }px`;
    } else {
      elementRef.current.style.paddingTop = 0;
    }
  }, [lessonViewer]);

  useEffect(() => {
    setPosition();
    window.addEventListener('resize', setPosition);
    window.addEventListener('scroll', setPosition);
    return () => {
      window.removeEventListener('resize', setPosition);
      window.removeEventListener('scroll', setPosition);
    };
  }, [setPosition]);

  return elementRef;
}

export default useAskTheExpertPosition;
